import merge from 'merge'

import { makePalette } from '@maxsystems/material-color-tool'

export default (colors, inherited = {}) => {
  colors = merge(inherited, colors)
  return Object.keys(colors).reduce((result, key) => {
    let color = colors[key]
    if (typeof color === 'string') {
      const [lighten5, lighten4, lighten3, lighten2, lighten1, base, darken1, darken2, darken3, darken4] = makePalette(color)
      color = { base, lighten5, lighten4, lighten3, lighten2, lighten1, darken1, darken2, darken3, darken4 }
    }
    result[key] = color
    return result
  }, {})
}
